import { useLayoutEffect } from "react"

import { Flex, Typography } from "antd"
import { useTranslation } from "react-i18next"
import { useDispatch, useSelector } from "react-redux"

import { getYourCommissions } from "../../redux/referrals.thunks"
import FromAlerts from "./FromAlerts"
import FromBonuses from "./FromBonuses"

import "./styles.less"

const { Title, Text } = Typography

const YourCommission = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const isMobile = useSelector((state) => state.nav.isMobile)

  useLayoutEffect(() => {
    dispatch(getYourCommissions())
  }, [])

  return (
    <div>
      <Title level={4} style={{ fontSize: isMobile && 16 }}>
        {t("Your commissions")}
      </Title>
      <Text type="secondary">
        {t("You earn in two ways: from every Alert your referred businesses receive and through")}
        {!isMobile && <br />}
        {t("Bonuses as their Alert volumes hit key milestones.")}
      </Text>
      <div style={{ padding: "24px 0" }}>
        <Flex gap={16} style={{ flexDirection: isMobile && "column" }}>
          <FromAlerts />
          <FromBonuses />
        </Flex>
      </div>
    </div>
  )
}

export default YourCommission
